import autobind from 'autobind-decorator';
import * as React from 'react';
import {withTranslation, WithTranslation} from 'react-i18next';
import {Alert, Button, Checkbox, Col, DatePicker, Empty, Form, Icon, Row, Select, Spin} from 'antd';
import {connect} from 'redux-scaffolding-ts';
import {Query} from 'src/core/stores/dataStore';
import 'react-splitter-layout/lib/index.css';
import HttpService, {formatMessage} from 'src/core/services/http.service';
import ElegibilityReportTable from '../../../components/elegibility-report-table';
import ElegibilityReportChart from '../../../components/elegibility-report-chart';
import DateRange, {checkDates, DateRangeValue} from '../../../components/dateRange';
import '../../../assets/custom.scss';
import {resolve} from '../../../inversify.config';
import moment from 'moment-timezone';
import {Moment} from 'moment'
import {ProjectSummary, ReportProjectsStore} from '../../../stores/projects-store';
import FileSaver from 'file-saver';
import {EmployeesReport, EmployeesReportStore} from '../../../stores/employee-report-store';
import {GetColors} from '../../../components/employees-report-chart';
import FormItem from 'antd/lib/form/FormItem';
import {nameof} from '../../../core/utils/object';
import {FormComponentProps, GetFieldDecoratorOptions} from 'antd/lib/form/Form';
import {EmployeeSummary, ReportEmployeesStore} from '../../../stores/employees-store';
import EditableTooltip from '../../../components/editable-tooltip/tooltip';
import { successNotification } from '../../../components/systemNotifications/notificationService';

const { Option } = Select;
const { RangePicker } = DatePicker

// tslint:disable-next-line:no-empty-interface
interface ProjectReportViewProps {
    companyName: string
    companyId: string
    isAdmin: boolean
    employeeId?: string
    currency: string
    allowCir: boolean;
    allowCii: boolean;
}

interface ProjectReportViewState {
    error?: string;
    projectsQuery: Query;
    employeesQuery: Query;
    timesheetsQuery: Query;
    isBusy: boolean;
    isPlotting: boolean;
    projects: ProjectSummary[];
    selectedProjectId: string;
    employees: EmployeeSummary[];
    employeesIndex: { [id: string]: EmployeeSummary }
    selectedEmployees: number[];
    employeesReport?: EmployeesReport;
    dataColors: string[];
    fromDateStamp: number;
    toDateStamp: number;
    chartRenderToggle: boolean;
    tasks: TaskReportRequest[];
    indexProjects: { [id: string]: ProjectSummary };
    cirHasValues: boolean
}

interface TaskReportRequest {
    id: number
    name: string
    proyectId: number
}
interface ProjectReportRequest {
    projects: ProjectSummary[];
    project?: number
    fromDateStamp: number;
    toDateStamp: number;
    from: Moment,
    to: Moment
    cir: boolean,
    cii: boolean,
    time: boolean,
    cost: boolean,
    employees: EmployeeSummary[];
    tasks: TaskReportRequest[];
    indexProjects: { [id: string]: ProjectSummary },
    indexEmployees: { [id: string]: EmployeeSummary },
}

interface ProjectReportForm {
    dateRange: DateRangeValue
    employees: string[];
    projects: string[];
    tasks: string[];
    cir: boolean,
    cii: boolean,
    time: boolean,
    cost: boolean,
}

interface ClassFormBodyProps extends WithTranslation {
    itemProj: ProjectReportRequest | undefined,
    onSave?: () => Promise<any>;
    getFieldDecorator<T extends Object = {}>(id: keyof T, options?: GetFieldDecoratorOptions): (node: React.ReactNode) => React.ReactNode;
    getFieldValue: (name: string) => any;
    validateFields: (fieldNames?: string[], options?: any, callback?: any) => void;
    setFieldsValue: any;
    isAdmin?: boolean;
    allowCir: boolean;
    allowCii: boolean;
}
interface ClassFormBodyState {
    ciiSelected: boolean,
    possibleEmployees: EmployeeSummary[],
    possibleProjects: ProjectSummary[],
    possibleTasks: any[],
}

class ReportFormBody extends React.Component<ClassFormBodyProps, ClassFormBodyState> {
    constructor(props: ClassFormBodyProps) {
        super(props);
        this.state = {
            ciiSelected: true,
            possibleEmployees: props.itemProj ? props.itemProj?.employees : [],
            possibleProjects: props.itemProj ? props.itemProj?.projects : [],
            possibleTasks: [] as object[]
        }
    }

    componentWillReceiveProps(nextProps: any) {
        if (nextProps.itemProj.employees.length !== this.props.itemProj?.employees.length || nextProps.itemProj.projects.length !== this.props.itemProj?.projects.length) {
            var emptyArr = [] as object[]
            var tasks = nextProps.itemProj ? emptyArr.concat.apply([], nextProps.itemProj!.projects.map((value: any, index: any) => {
                var options = value.tasks.filter((t: any) => t.item3 || t.item4)
                return options
            })) : [] as any[]
            this.setState({
                possibleEmployees: nextProps.itemProj?.employees,
                possibleProjects: nextProps.itemProj?.projects,
                possibleTasks: tasks
            });
        }
    }

    @autobind
    private async validatProjectSelection(rule: any, value: any) {
        const { t } = this.props;
        if (value === undefined) {
            throw new Error(t('Project must be specified'))
        }
    }

    @autobind
    private async validateEmployees(rule: any, value: any, callback: any) {
        const { t } = this.props;
        if (value == undefined || (value as any[]).length == 0) {
            callback()
        }
    }

    @autobind
    private validateSchemeCir(rule: any, date: Moment, callback: any) {
        var cir = this.props.getFieldValue('cir')
        var cii = this.props.getFieldValue('cii')
        if (cir || cii) {
            this.props.validateFields([nameof<ProjectReportRequest>('cii')], { force: true })
            callback();
        }
        else {
            const { t } = this.props;
            callback(t('At least one scheme must be selected'));
        }

    }

    @autobind
    private validateSchemeCii(rule: any, date: Moment, callback: any) {
        var cir = this.props.getFieldValue('cir')
        var cii = this.props.getFieldValue('cii')
        if (cir || cii) {
            this.props.validateFields([nameof<ProjectReportRequest>('cir')], { force: true })
            callback();
        }
        else {
            const { t } = this.props;
            callback(t('At least one scheme must be selected'));
        }

    }

    @autobind
    private validateUnitTime(rule: any, date: Moment, callback: any) {
        var time = this.props.getFieldValue('time')
        var cost = this.props.getFieldValue('cost')
        if (time || cost) {
            this.props.validateFields([nameof<ProjectReportRequest>('cost')], { force: true })
            callback();
        } else {
            const { t } = this.props;
            callback(t('At least one unit must be selected'));
        }

    }
    @autobind
    private validateUnitCost(rule: any, date: Moment, callback: any) {
        var time = this.props.getFieldValue('time')
        var cost = this.props.getFieldValue('cost')
        if (time || cost) {
            this.props.validateFields([nameof<ProjectReportRequest>('time')], { force: true })
            callback();
        } else {
            const { t } = this.props;
            callback(t('At least one unit must be selected'));
        }
    }

    @autobind
    private onEmployeesChange(e: string[]) {
        var possibleProjects = this.props.itemProj ? this.props.itemProj!.projects.filter(p => p.rdTaxRelief == this.props.getFieldValue('cir') || p.tiTaxRelief == this.props.getFieldValue('cii')) : [] as ProjectSummary[]
        var ids = possibleProjects.map((value, index) => { return value.id })
        this.setState({ possibleProjects: possibleProjects },
            () => {
                this.props.setFieldsValue({ projects: possibleProjects.map((value, index) => { return value.id }) });
                this.onProjectsChange(ids);
            }
        )
    }

    @autobind
    private onProjectsChange(e: any) {
        var emptyArr = [] as object[]
        var possibleTasks = emptyArr.concat.apply([], e.map((value: any, index: any) => {
            var options = this.props.itemProj ? this.props.itemProj.indexProjects[value].tasks.filter((t: any) => {
                if (t.item3 && this.props.getFieldValue('cir') || t.item4 && this.props.getFieldValue('cii'))
                    return true
            }) : [] as object[]
            return options
        }))
        this.setState({
            possibleTasks: possibleTasks
        }, () => this.props.setFieldsValue({ tasks: possibleTasks.map((value: any, index) => { return value.item1 }) }))
    }

    @autobind
    private onCirChange(e: any) {
        if (!this.props.getFieldValue(nameof<ProjectReportRequest>('cii'))) {
            this.props.validateFields([nameof<ProjectReportRequest>('cii')], { force: true })
        }

        var employees = this.props.itemProj ? this.props.itemProj!.employees.filter(emp => emp.cirEligible == e.target.checked || emp.ciiEligible == this.props.getFieldValue('cii')) : [] as EmployeeSummary[]
        this.setState({ possibleEmployees: employees }, () => {
            this.props.setFieldsValue({ employees: employees.map((value: any, index) => { return value.id }) })
            var ids = employees.map((value, index) => { return value.id.toString() })
            this.onEmployeesChange(ids)
        })
    }

    @autobind
    private onCiiChange(e: any) {

        if (!this.props.getFieldValue(nameof<ProjectReportRequest>('cir'))) {
            this.props.validateFields([nameof<ProjectReportRequest>('cir')], { force: true })
        }

        var employees = this.props.itemProj ? this.props.itemProj!.employees.filter(emp => emp.cirEligible == this.props.getFieldValue('cir') || emp.ciiEligible == e.target.checked) : [] as EmployeeSummary[]
        this.setState({ possibleEmployees: employees }, () => {
            this.props.setFieldsValue({ employees: employees.map((value: any, index) => { return value.id }) })
            var ids = employees.map((value, index) => { return value.id.toString() })
            this.onEmployeesChange(ids)
        })
    }

    render() {
        const { t, isAdmin } = this.props;
        var defaultprojects = this.state.possibleProjects?.map((value, index) => {
            return value.id.toString()
        })
        var defaultemployees = this.state.possibleEmployees?.map((value, index) => {
            return value.id.toString()
        })
        var defaultTasks = this.state.possibleTasks ?
            this.state.possibleTasks.map((t: any, i: number) => {
                return t.item1
            }) : []
        const tasksMenu = this.state.possibleTasks!.map((t: any, i: number) => {
            return <Option key={t.item1} value={t.item1} >{t.item2}</Option>
        })

        const projectsMenu = this.state.possibleProjects.map((value, index) => {
            return <Option value={`${value.id}`}>{value.title}</Option>
        })

        const employeesMenu = this.state.possibleEmployees.map((value, index) => {
            return <Option key={value.id} value={`${value.id}`}>{value.title}</Option>
        })

        return <Form id="modaForm">
            <Row type='flex' gutter={16}>
                <Col>
                    <div data-tut="reactour__navegateReport2e" >
                        <FormItem label={t('Period')}>
                            {this.props.getFieldDecorator(nameof<ProjectReportForm>('dateRange'), {
                                rules: [{ required: true, validator: checkDates(t)}],
                                initialValue: {
                                    startDate: moment().startOf('month'),
                                    endDate: moment().endOf('month')
                                } as DateRangeValue
                            })(
                                <DateRange />
                            )}
                        </FormItem>
                    </div>
                </Col>
                {isAdmin && <Col>
                    <FormItem className={"custom-form-item-message"} style={{ minWidth: 300, maxWidth: 300 }} label={t("Employees")}>
                        <div data-tut="reactour__navegateReport1e">
                            {this.props.getFieldDecorator(nameof<ProjectReportForm>('employees'), {
                                initialValue: defaultemployees, rules: [{ required: true, message: t('At least one employee must be selected') }, { validator: this.validateEmployees }],
                            })(
                                <Select
                                    mode="multiple"
                                    className={"custom-select-multiple"}
                                    style={{ minWidth: 300, maxWidth: 300 }}
                                    placeholder={t('Employees')}
                                    onChange={this.onEmployeesChange}
                                    filterOption={(input, option) => {
                                        if (option.props.children)
                                            return option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                        return false;
                                    }}>
                                    {employeesMenu}
                                </Select>
                            )}
                        </div>
                    </FormItem>
                </Col>}
                <div data-tut="reactour__navegateReport3e" style={{ display: 'flex' }}>
                <Col>
                    <FormItem className={"custom-form-item-message"} style={{ minWidth: 300, maxWidth: 300 }} label={t("Projects")}>
                        <div>
                            {this.props.getFieldDecorator(nameof<ProjectReportForm>('projects'), {
                                initialValue: defaultprojects, rules: [{ required: true, message: t('At least one project must be selected') }, { validator: this.validatProjectSelection }],
                            })(
                                <Select
                                    mode="multiple"
                                    className={"custom-select-multiple"}
                                    style={{ minWidth: 300, maxWidth: 300 }}
                                    placeholder={t('Projects')}
                                    onChange={this.onProjectsChange}
                                    filterOption={(input, option) => {
                                        if (option.props.children)
                                            return option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                        return false;
                                    }}>
                                    {projectsMenu}
                                </Select>
                            )}
                        </div>
                    </FormItem>
                </Col>
                <Col>
                    <FormItem className={"custom-form-item-message"} style={{ minWidth: 300, maxWidth: 300 }} label={t("Tasks")}>
                        <div>
                            {this.props.getFieldDecorator(nameof<ProjectReportForm>('tasks'), {
                                initialValue: defaultTasks, rules: [{ required: true, message: t('At least one task must be selected') }, { validator: this.validatProjectSelection }],
                            })(
                                <Select
                                    mode="multiple"
                                    className={"custom-select-multiple"}
                                    style={{ minWidth: 300, maxWidth: 300 }}
                                    placeholder={t('Tasks')}
                                    filterOption={(input, option) => {
                                        if (option.props.children)
                                            return option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                        return false;
                                    }}>
                                    {tasksMenu}
                                </Select>
                            )}
                        </div>
                    </FormItem>
                    </Col>
                </div>
            </Row>
            <br />
            <div data-tut="reactour__navegateReport4e" style={{ display: 'flex', minWidth: 650, maxWidth: 650 }}>
            <div style={{ minWidth: 316, maxWidth: 316, whiteSpace: 'nowrap', display: 'inline-block' }}>
                <div className="ant-col ant-form-item-label" >
                    <label title="Scheme">{t("Scheme")}</label>
                </div>
                <br />
                <FormItem style={{ display: 'inline-block' }}>
                    {this.props.getFieldDecorator(nameof<ProjectReportForm>('cir'), {
                        rules: [{ required: false, message: t('At least one scheme must be selected') }, { validator: this.validateSchemeCir }
                        ], initialValue: this.props.allowCir, valuePropName: 'checked'
                    })(
                        <Checkbox disabled={!this.props.allowCir} onChange={this.onCirChange}>{t('CIR')}</Checkbox>

                    )}
                </FormItem>
                <br />
                <FormItem style={{ display: 'inline-block' }}>
                    {this.props.getFieldDecorator(nameof<ProjectReportForm>('cii'), {
                        rules: [{ required: false, message: t('At least one scheme must be selected') }, { validator: this.validateSchemeCii }
                        ], initialValue: this.props.allowCii, valuePropName: 'checked'
                    })(
                        <Checkbox disabled={!this.props.allowCii} onChange={this.onCiiChange} >{t("CII")}</Checkbox>
                    )}
                </FormItem>
            </div>

            <div style={{ whiteSpace: 'nowrap', display: 'inline-block', minWidth: 300, maxWidth: 300 }}>
                <div className="ant-col ant-form-item-label" >
                    <EditableTooltip name='eligibility-report-units'>
                        <label style={{ display: 'inline-block' }} title="Units">{t("Units")}</label>
                    </EditableTooltip>
                </div>
                <br />
                <FormItem style={{ display: 'inline-block' }}>
                    {this.props.getFieldDecorator(nameof<ProjectReportForm>('time'), {
                        rules: [{ required: false, message: t('At least one unit must be selected') }, { validator: this.validateUnitTime }
                        ], initialValue: true, valuePropName: 'checked'
                    })(
                        <Checkbox>{t('Time')}</Checkbox>

                    )}
                </FormItem>
                <br />
                <FormItem style={{ display: 'inline-block' }} >
                    {this.props.getFieldDecorator(nameof<ProjectReportForm>('cost'), {
                        rules: [{ required: false, message: t('At least one unit must be selected') }, { validator: this.validateUnitCost }
                        ], initialValue: true, valuePropName: 'checked'
                    })(
                        <Checkbox>{t('Estimated cost')}</Checkbox>
                    )}
                </FormItem>
                </div>
            </div>
            <br />
            <FormItem >
                <div data-tut="reactour__navegateReport3"   >
                    <Button
                        data-tut="reactour__navegateReport5e"
                        disabled={!(this.props.allowCii || this.props.allowCir)}
                        onClick={() => { if (this.props.onSave) { this.props.onSave(); } }}
                        style={{ paddingRight: 11, paddingLeft: 10 }}>
                        <Icon type='eye' />
                        {t('Generate report')}
                    </Button>
                </div>
            </FormItem>
        </Form>
    }
}

@connect(['projects', ReportProjectsStore], ["employeesReport", EmployeesReportStore], ['employees', ReportEmployeesStore])
class ProjectsReportDashboard extends React.Component<ProjectReportViewProps & WithTranslation & FormComponentProps<ProjectReportForm>, ProjectReportViewState> {

    @resolve(HttpService)
    private httpService!: HttpService;

    private get projectsStore() {
        return (this.props as any).projects as ReportProjectsStore;
    }
    private get employeesStore() {
        return (this.props as any).employees as ReportEmployeesStore;
    }
    private get employeesReportStore() {
        return (this.props as any).employeesReport as EmployeesReportStore;
    }

    constructor(props: ProjectReportViewProps & WithTranslation & FormComponentProps) {
        super(props);
        this.state = {
            employeesQuery: {
                searchQuery: '',
                orderBy: [{ field: 'name', direction: 'Ascending', useProfile: false }],
                skip: 0,
                take: 1000,
                filter: { Id: !props.isAdmin ? { eq: { type: 'guid', value: props.employeeId } } : undefined }
            },
            projectsQuery: {
                searchQuery: '',
                orderBy: [{ field: 'title', direction: 'Ascending', useProfile: false }],
                skip: 0,
                take: 1000,
            },
            timesheetsQuery: {
                searchQuery: '',
                orderBy: [{ field: 'fromDate', direction: 'Ascending', useProfile: true }],
                skip: 0,
                take: 1000
            },
            isBusy: false,
            isPlotting: false,
            projects: [],
            tasks: [],
            selectedProjectId: "",
            employees: [],
            employeesIndex: {},
            indexProjects: {},
            selectedEmployees: [],
            dataColors: [],
            fromDateStamp: 0,
            toDateStamp: 0,
            chartRenderToggle: false,
            cirHasValues: false
        };
        this.projectsStore.changeUrl(props.companyId);
    }

    componentWillMount() {
        this.loadEmployees(this.state.employeesQuery)
    }

    @autobind
    private loadProjects(query: Query) {
        var self = this
        this.setState({ isBusy: true });
        this.projectsStore.getAllAsync(query, undefined, this.props.companyId).then(result => {
            let projects = result.items as ProjectSummary[]
            var projectsIndex: { [id: string]: ProjectSummary } = {}
            projects = projects.filter(p => p.rdTaxRelief || p.tiTaxRelief)
            projects.forEach((value, index) => { projectsIndex[value.id.toString()] = value })
            var tasks = [].concat.apply([], projects.map((value: any, index: any) => {
                var options = value.tasks.filter((t: any) => t.item3 || t.item4)
                return options
            }))
            self.setState({
                isBusy: false,
                projects: projects,
                indexProjects: projectsIndex,
                tasks: tasks,
            });
        }).catch(error => {
            this.setState({ error: formatMessage(error), isBusy: false })
        });
    }

    @autobind
    private async loadEmployees(query: Query) {
        var employeesIndex: { [id: string]: EmployeeSummary } = {}
        this.setState({ isBusy: true });
        this.employeesStore.changeAdminUrl(this.props.companyId)
        await this.employeesStore.getAllAsync(query).then(result => {
            let employees = result.items as EmployeeSummary[]
            employees = employees.filter(e => e.ciiEligible || e.cirEligible)
            employees.forEach((value, index) => { employeesIndex[value.id.toString()] = value })
            this.setState({
                isBusy: false,
                employees: employees,
                employeesIndex: employeesIndex
            }, () => this.loadProjects(this.state.projectsQuery));
        }).catch(error => {
            this.setState({ error: formatMessage(error), isBusy: false })
        });
    }
    @autobind
    private onCreateNewItem() {
        var self = this;
        return new Promise((resolve, reject) => {
            self.props.form.validateFields(event => {
                var values = self.props.form.getFieldsValue() as ProjectReportForm;
                if (!event) {
                    let fromDateStamp = values.dateRange.startDate!.startOf("day").unix();
                    let toDateStamp = values.dateRange.endDate!.endOf("day").unix();
                    let queryTimesheets = {
                        ...self.state.timesheetsQuery,

                        parameters: {
                            'queryFromDateStamp': values.dateRange.startDate!.clone().startOf("isoWeek").startOf("day").unix(),
                            'queryToDateStamp': values.dateRange.endDate!.clone().endOf("isoWeek").endOf("day").unix(),
                            'fromDateStamp': fromDateStamp,
                            'toDateStamp': toDateStamp,
                            'ciiEligibility': values.cii.toString(),
                            'cirEligibility': values.cir.toString(), 
                            'export':'false'
                        }
                    }

                    self.setState({
                        timesheetsQuery: queryTimesheets,
                        fromDateStamp: fromDateStamp,
                        toDateStamp: toDateStamp,
                    })
                    var data = {
                        'employeesIds': values.employees,
                        'projectsIds': values.projects,
                        'tasksIds': values.tasks,
                    }
                    self.loadEmployeesReport(queryTimesheets, data)
                }
            });
        })
    }

    @autobind
    private async loadEmployeesReport(queryTimesheets: Query, data:any) {
        const { isAdmin } = this.props

        this.setState({
            isBusy: true,
            isPlotting: false
        })
        var url = '';
        if (isAdmin)
            url = `${process.env.PUBLIC_URL}/api/v1/admin/companies/${this.props.companyId}/timesheets/report/elegibility`;
        else
            url = `${process.env.PUBLIC_URL}/api/v1/timesheet/${this.props.companyId}/report/elegibility`;
        url = `${url}?${EmployeesReportStore.buildUrl(queryTimesheets)}`
        this.httpService.post<any, EmployeesReport>(url, data).then(result => {

            let employeesReport = result.data;
            employeesReport.projectIdToName = new Map(Object.entries(employeesReport.projectIdToName).toArray())
            employeesReport.projectTaskIdToName = new Map(Object.entries(employeesReport.projectTaskIdToName).toArray())
            employeesReport.tasksToProjects = new Map(Object.entries(employeesReport.tasksToProjects).toArray())
            employeesReport.projectIdToCii = new Map(Object.entries(employeesReport.projectIdToCii).toArray())
            employeesReport.projectIdToCir = new Map(Object.entries(employeesReport.projectIdToCir).toArray())
            employeesReport.taskIdToCii = new Map(Object.entries(employeesReport.taskIdToCii).toArray())
            employeesReport.taskIdToCir = new Map(Object.entries(employeesReport.taskIdToCir).toArray())
            employeesReport.reports.forEach(report => {
                report.workedHoursPerProject = new Map(Object.entries(report.workedHoursPerProject).toArray())
                report.workedHoursPerProjectByMonth = new Map(Object.entries(report.workedHoursPerProjectByMonth).toArray())
                report.workedHoursPerTask = new Map(Object.entries(report.workedHoursPerTask).toArray())
                report.workedHoursPerTaskByMonth = new Map(Object.entries(report.workedHoursPerTaskByMonth).toArray())
            })

            this.setState({
                employeesReport: employeesReport,
                isBusy: false,
                isPlotting: (employeesReport.reports.length > 0),
                dataColors: GetColors(employeesReport.reports.length)
            });
        }).catch(error => {
            this.setState({ error: formatMessage(error), isBusy: false })
            return
        })
    }

    @autobind
    private cirTableHasValues(hasValues: boolean) {
        this.setState({ cirHasValues: hasValues })
    }

    @autobind
    private async onDownload(format: string): Promise<boolean> {
        const { isAdmin, form } = this.props
        try {
            this.setState({ isBusy: true });
            var values = form.getFieldsValue();
            let queryTimesheets = {
                ...this.state.timesheetsQuery,
                parameters: {
                    'queryFromDateStamp': values.dateRange.startDate!.clone().startOf("isoWeek").startOf("day").unix(),
                    'queryToDateStamp': values.dateRange.endDate!.clone().endOf("isoWeek").endOf("day").unix(),
                    'fromDateStamp': this.state.fromDateStamp,
                    'toDateStamp': this.state.toDateStamp,
                    'ciiEligibility': values.cii.toString(),
                    'cirEligibility': values.cir.toString(),
                    'export': 'true',
                    'format': format,
                }
            }
            var data = {
                'employeesIds': values.employees,
                'projectsIds': values.projects,
                'tasksIds': values.tasks,
            }

            var url = '';
            if (isAdmin)
                url = `${process.env.PUBLIC_URL}/api/v1/admin/companies/${this.props.companyId}/timesheets/report/elegibility`;
            else
                url = `${process.env.PUBLIC_URL}/api/v1/timesheet/${this.props.companyId}/report/elegibility`;
            url = `${url}?${EmployeesReportStore.buildUrl(queryTimesheets)}`
           

            var result = await this.httpService.post<any, EmployeesReport>(url, data, { responseType: 'arraybuffer' });
            successNotification(this.props.t('Operation Completed Successfully'), this.props.t('Your operation will be processed in background.'));
            this.setState({ isBusy: false });
            return true;
        } catch (error) {
            this.setState({ isBusy: false, error: formatMessage(error) });
            return false;
        }
    }

    public render() {
        const { t, isAdmin } = this.props;
        const { getFieldDecorator, getFieldValue, validateFields, setFieldsValue } = this.props.form;


        let reportRequestProj: ProjectReportRequest = {
            projects: this.state.projects,
            employees: this.state.employees,
            project: undefined,
            indexProjects: this.state.indexProjects,
            indexEmployees: this.state.employeesIndex,
            fromDateStamp: this.state.fromDateStamp,
            toDateStamp: this.state.toDateStamp,
            from: moment(),
            to: moment(),
            cir: true,
            cii: true,
            time: true,
            cost: true,
            tasks: []
        }

        const noEmployees = this.state.employees.length == 0;
        const noProjects = !noEmployees && this.state.projects.length == 0;
        const noTasks = !noProjects && this.state.tasks.length == 0;
        const companyNoEligible =  !(this.props.allowCir || this.props.allowCii)
        const employeeErrorMessage = noEmployees && (!isAdmin ?
            t("Current employee is not established as eligible for CIR or CII") :
            t("There is no employee set as CIR or CII eligible"));
        const projectErrorMessage = noProjects && t("There is no project set as CIR or CII eligible");
        const taskErrorMessage = noTasks && t("There is no task set as CIR or CII eligible");
        const companyErrorMessage = companyNoEligible && t("Company is not set as CIR or CII eligible");

        return <div>
            <Spin size='large' spinning={this.state.isBusy}>
                <Row type={'flex'} align='top' justify='space-between'>
                    {(noEmployees || noProjects || noTasks || companyNoEligible) &&
                        <Alert type='error' message={employeeErrorMessage || projectErrorMessage || taskErrorMessage || companyErrorMessage} />}
                    {this.state.error && <Alert type='error' message={this.state.error} />}
                    {(isAdmin || !noEmployees) &&
                        <div style={{ top: 0, backgroundColor: 'white', zIndex: 100, width: "100%" }}>
                            <ReportFormBody
                                i18n={this.props.i18n}
                                t={this.props.t}
                                tReady={this.props.tReady}
                                itemProj={reportRequestProj}
                                getFieldDecorator={getFieldDecorator}
                                getFieldValue={getFieldValue}
                                validateFields={validateFields}
                                setFieldsValue={setFieldsValue}
                                isAdmin={isAdmin}
                                onSave={this.onCreateNewItem}
                                allowCir={this.props.allowCir}
                                allowCii={this.props.allowCii} />

                            {this.state.isPlotting && getFieldValue('cir') &&
                                <div>
                                    <div style={{ marginTop: 20, width: "100%" }}>
                                        <ElegibilityReportTable
                                            data={this.state.employeesReport as EmployeesReport}
                                            onDownload={this.onDownload}
                                            cir={true}
                                            time={getFieldValue('time')}
                                            cost={getFieldValue('cost')}
                                            elegibility={true}
                                            hasValues={this.cirTableHasValues}
                                            currency={this.props.currency}
                                        />
                                    </div>
                                    <div style={{ marginTop: 20, width: "100%" }}>
                                        <ElegibilityReportChart
                                            renderToggle={this.state.chartRenderToggle}
                                            data={this.state.employeesReport as EmployeesReport}
                                            projectId={this.state.selectedProjectId}
                                            colors={this.state.dataColors}
                                            showBar={true}
                                            showPie={true}
                                            cost={getFieldValue('cost')}
                                            cir={true}
                                            time={getFieldValue('time')}
                                        />
                                    </div>
                                </div>}
                            {this.state.isPlotting && getFieldValue('cii') &&
                                <div>
                                    <div style={{ marginTop: 20, width: "100%" }}>
                                        <ElegibilityReportTable
                                            data={this.state.employeesReport as EmployeesReport}
                                            onDownload={(getFieldValue('cir') && this.state.cirHasValues) ? undefined : this.onDownload}
                                            cir={false}
                                            time={getFieldValue('time')}
                                            cost={getFieldValue('cost')}
                                            currency={this.props.currency}
                                            elegibility={true}
                                        />
                                    </div>
                                    <div style={{ marginTop: 20, width: "100%" }}>
                                        <ElegibilityReportChart
                                            renderToggle={this.state.chartRenderToggle}
                                            data={this.state.employeesReport as EmployeesReport}
                                            projectId={this.state.selectedProjectId}
                                            colors={this.state.dataColors}
                                            showBar={true}
                                            showPie={true}
                                            time={getFieldValue('time')}
                                            cost={getFieldValue('cost')}
                                            cir={false}
                                        />
                                    </div>
                                </div>}
                            {!this.state.isPlotting && <Empty />}
                        </div>
                    }
                </Row>
            </Spin>
        </div>
    }
}
// Wire up the React component to the Redux store
export default withTranslation()(Form.create({})(ProjectsReportDashboard as any) as any) as any as React.ComponentClass<ProjectReportViewProps>;